import React, { useEffect, useState, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "primereact/button";
import SettlementActions from "../../Redux/transition/settlement/settlement.reducer";
import PlanGroupActions from "../../Redux/transition/plan-group/plan-group.reducer";
import DefMembershipActions from "../../Redux/actions/defMembership-actions";
import PaymentTrackActions from "../../Redux/transition/payment-track/payment-track.reducer";
import "../../Styles/pages/products.scss";
import "../../Styles/pages/product.scss"
import "../../Styles/pages/customers.scss"
import { Paginator } from "primereact/paginator";
import MarkAsPaid from "../../Components/MarkAsPaid";
import { Dialog } from "primereact/dialog";
import { ConfirmDialog } from 'primereact/confirmdialog';
import PlanActions from "../../Redux/transition/plan/plan.reducer";
import { Toast } from "primereact/toast";
import ProductEdit from "./ProductEdit";
import CustomDataTable from "../../Components/CustomDataTable";
import ProductDetailCardInsights from "./ProductDetailCardInsights"
import { useDateFormatter } from "../../Components/FormatDateTime";
import { FormatCurrency, useCurrencyConstants } from '../../Components/CurrencyFormatter';
import SharePlan from "../../Components/SharePlan";
import ShareUrl from "../../Pages/Products/ShareUrl";
import { formatBillingPeriodText } from "../../Components/CleanInputs";
import AutoBillingBadge from "../../Components/AutoBillingBadge";

const ProductDetail = () => {

    const { formatDateTime } = useDateFormatter();

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation("common");
    const { id: planId } = useParams();
    const [displayBasic, setDisplayBasic] = useState(false);
    const [archive, setArchive] = useState(false);
    const [tierArchive, setTierArchive] = useState(false);
    const [productInfoVisible, setProductInfoVisible] = useState({})
    const [editProductToast, setEditProductToast] = useState(false)
    const [activeTab, setActiveTab] = useState(0)
    const [triggerRender, setTriggerRender] = useState(false)

    const [sharePlanDialog, setSharePlanDialog] = useState(false);
    const [reportable, setReportable] = useState(false);
    const [reportCode, setReportCode] = useState("");
    const [hideAmount, setHideAmount] = useState(false)
    const [dialogClosed, setDialogClosed] = useState(false);
    const [shareDialog, setShareDialog] = useState(false);
    const [createLeaderboard, setCreateLeaderBoard] = useState(false);



    const toast = useRef(null);

    const [state, setState] = useState({
        planGroup: {},
        layout: "list",
        sort: "plan.name,desc",
        count: null,
        size: 15,
        first: 0,
        page: 0,
        loading: true,
        withdrawals: [],
        performance: {},
        tiers: [],
        totalPlanSummaryCount: 0,
        customers: [],
        paid: [],
        missed: [],
        pending: [],
        paidCount: 0,
        pendingCount: 0,
        missedCount: 0,
        visibleCreate: false,
        marking: true,
        id: null,
        planExternalPayments: [],
        isAmountTrue: null,
        productExternalPayments: [],
        sharedPlan: {},
        productExternalPaymentsCount: 0,
        scheduledFor: "scheduledDate,desc",
        planSummarySort: "plan.lastModifiedDate,desc",
        sortPlans: "lastModifiedDate,asc",
        confirmVisible: false,
        sharedTier: {}
    });

    const defMembership = useSelector((state) => state.defMembership.defMembership);
    const {
        planGroup,
        tiers,
        missed,
        missedCount,
        pending,
        pendingCount,
        fetchingPending,
        performance,
        fetchingPerformance,
        fetchingPlansSummary,
        customersSummary,
        plansSummary,
    } = useSelector((state) => state.planGroups);

    const { creating } = useSelector((state) => state.plans);
    const { sourcePlanGroups, fetchingSourcePlanGroups } = useSelector((state) => state.settlements);
    const { paymentTrackGroup, paymentTrackGroupCount, planPayments } = useSelector((state) => state.paymentTracks);
    const archiving = useSelector((state) => state.planGroups.archiving);
    const successArchiving = useSelector((state) => state.planGroups.archiveSuccess);
    const archivingPlan = useSelector((state) => state.plans.archiving);
    const archivingPlanSuccess = useSelector((state) => state.plans.archiveSuccess);
    const archivingPlanError = useSelector((state) => state.plans.errorArchiving);
    const errorArchiving = useSelector((state) => state.planGroups.errorArchiving);
    const planGroupExternalPayments = useSelector((state) => state.paymentTracks.groupPayments)
    const creatingLeaderBoard = useSelector((state) => state.planGroups.creatingLeaderBoard)
    const successLeaderBoard = useSelector((state) => state.planGroups.boardUrl)
    const errorLeaderBoard = useSelector((state) => state.planGroups.leaderBoardError)

    const getMembership = useCallback(() => { dispatch(DefMembershipActions.defMembershipRequest()); }, [dispatch]);
    const getPlanGroup = useCallback((planId, options) => dispatch(PlanGroupActions.planGroupRequest(planId, options)), [dispatch]);
    const getPlanGroupPerformance = useCallback((planId, options) => dispatch(PlanGroupActions.planGroupPerformanceRequest(planId, options)), [dispatch]);
    const getPlanGroupPaymentMissed = useCallback((planId, options) => dispatch(PlanGroupActions.planGroupPaymentMissedRequest(planId, options)), [dispatch]);
    const getPlanGroupPaymentMissedCount = useCallback((planId) => dispatch(PlanGroupActions.planGroupPaymentMissedCountRequest(planId)), [dispatch]);
    const getPlanGroupPaymentPending = useCallback((planId, options) => dispatch(PlanGroupActions.planGroupPaymentPendingRequest(planId, options)), [dispatch]);
    const getPlanGroupPaymentPendingCount = useCallback((planId) => dispatch(PlanGroupActions.planGroupPaymentPendingCountRequest(planId)), [dispatch]);
    const getTiers = useCallback((planId, options) => dispatch(PlanGroupActions.planGroupTierRequest(planId, options)), [dispatch]);
    const getPlanGroupPlansSummary = useCallback((planId, options) => dispatch(PlanGroupActions.planGroupPlansSummaryRequest(planId, options)), [dispatch]);
    const getPlanGroupCustomersSummary = useCallback((planId, options) => dispatch(PlanGroupActions.planGroupCustomersSummaryRequest(planId, options)), [dispatch]);
    const getSettlementsGroup = useCallback((planId, options) => dispatch(SettlementActions.settlementSourcesGroupRequest(planId, options)), [dispatch]);
    const getPaymentTrackGroup = useCallback((planId, options) => dispatch(PaymentTrackActions.paymentTrackGroupRequest(planId, options)), [dispatch]);
    const getPaymentTrackGroupCount = useCallback((planId, options) => dispatch(PaymentTrackActions.paymentTrackGroupCountRequest(planId, options)), [dispatch]);
    const getPlanExternalPayments = useCallback((businessId, planId, options) => { dispatch(PaymentTrackActions.planGroupExternalPaymentsRequest(businessId, planId, options)) }, [dispatch]);
    const archivePlanGroup = useCallback((planGroupId, username) => { dispatch(PlanGroupActions.planGroupArchiveRequest(planGroupId, username)); }, [dispatch]);
    const archivePlan = useCallback((planId, membershipId) => { dispatch(PlanActions.planArchiveRequest(planId, membershipId)); }, [dispatch]);
    const getActivePlanGroups = useCallback((businessId) => { dispatch(PlanGroupActions.planGroupGraphedActiveRequest(businessId)); }, [dispatch]);
    const leaderBoard = useCallback((planGroupId) => { dispatch(PlanGroupActions.leaderBoardRequest(planGroupId)) }, [dispatch])

    useEffect(() => {
        if (!defMembership) {
            getMembership();
        }
        getPlanGroup(planId);
        getSettlementsGroup(planId);
        getTiers(planId, { sort: state.sortPlans, size: state.size });
        getPlanGroupPaymentPending(planId, { sort: state.scheduledFor, size: state.size });
        getPlanGroupPaymentPendingCount(planId);
        getPlanGroupPlansSummary(planId, { size: state.size, sort: state.planSummarySort });
    },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [defMembership, planId, triggerRender]);


    const onHidePlan = () => {
        setState((state) => {
            return { ...state, visibleCreate: false };
        });
    };

    useEffect(() => {
        if (!archivingPlan && state.planArchiving && archivingPlanSuccess) {
            showSuccess({
                message: t("product.tierArchive_successful"),
                severity: "success",
            });
            setState((state) => ({ ...state, planArchiving: false }));
        }
        if (archivingPlan && state.planArchiving && archivingPlanError) {
            showError();
            setState((state) => ({ ...state, planArchiving: false }));
        }
        if (!archiving && state.archived && successArchiving) {
            toast.current.show({
                severity: "success",
                summary: t("product.success_summary"),
                detail: t("product.archive_successful"),
                life: 3000,
            });
            setState((state) => ({ ...state, archived: false }));
        }
        if (archiving && state.archived && errorArchiving) {
            showError();
            setState((state) => ({ ...state, archived: false }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [archiving, successArchiving, errorArchiving, state.archived, state.planArchiving, archivingPlan, archivingPlanSuccess, archivingPlanError,]);


    useEffect(() => {
        if (!creating) {
            getTiers(planId, { sort: state.sortPlans, size: state.size });
            getPlanGroupPerformance(planId);
            onHidePlan();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [creating, planId]);

    useEffect(() => {
        if (planGroup) {
            setState((state) => {
                return { ...state, planGroup: planGroup };
            });

        }
        if (performance) {
            setState((state) => {
                return { ...state, performance: performance };
            });
        }
        if (plansSummary) {
            setState((state) => {
                return { ...state, tiers: plansSummary?.content, totalPlanSummaryCount: plansSummary?.totalElements };
            });
        }
        if (customersSummary) {
            setState((state) => {
                return { ...state, customers: customersSummary };
            });
        }
        if (pending) {
            setState((state) => ({ ...state, pending: pending?.content }));
        }
        if (pendingCount) {
            setState((state) => ({ ...state, pendingCount: pendingCount }));
        }
        if (planPayments) {
            setState((state) => { return { ...state, planExternalPayments: planPayments.content } })
        }
    }, [
        fetchingSourcePlanGroups,
        performance,
        planGroup,
        tiers,
        missed,
        pending,
        missedCount,
        pendingCount,
        paymentTrackGroup,
        paymentTrackGroupCount,
        sourcePlanGroups,
        plansSummary,
        customersSummary,
        planPayments, state.planExternalPayments, planGroupExternalPayments, state.productExternalPayments, state.planGroup
    ]);

    useEffect(() => {
        if (tabs[activeTab].index === 0) {
            getPlanGroupPlansSummary(planId, { sort: state.planSummarySort, size: state.size });
        }
        if (tabs[activeTab].index === 3) {
            getPlanGroupPaymentPending(planId, { sort: state.scheduledFor, size: state.size });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTab])

    const { currencyFormat, currencySymbol } = useCurrencyConstants(); useEffect(() => {
        if (state.planGroup) {
            setDialogClosed(false);
            setReportable(state.planGroup.reportable);
            setReportCode(state.planGroup.reportCode);
            setHideAmount(state.planGroup.hideAmount);
            setState((state) => ({
                ...state,
                sharedPlan: {
                    shortUrl: state.planGroup.shortUrl,
                    plan: state.planGroup.name,
                    planDescription: state.planGroup.description,
                    planGroupId: state.planGroup.id,
                    reportable: state.planGroup.reportable,
                    reportCode: state.planGroup.reportCode,
                    hideAmount: state.planGroup.hideAmount,
                }
            }))
        }
        if (dialogClosed) {
            getPlanGroup(planId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.planGroup, dialogClosed, planId])

    useEffect(() => {
        if (createLeaderboard && creatingLeaderBoard) {
            setShareDialog(true);
        }

        if (!creatingLeaderBoard && successLeaderBoard && createLeaderboard) {
            getPlanGroup(planId);
            setState((prev) => ({
                ...prev,
                sharedTier: {
                    shortUrl: successLeaderBoard.boardUrl,
                    plan: `${t("product.leaderBoard_for")} ${successLeaderBoard.name}`,
                    planGroupId: successLeaderBoard.id,
                    isLeaderboard: true,
                },
            }));

            setCreateLeaderBoard(false);
        }

        if (!creatingLeaderBoard && errorLeaderBoard && createLeaderboard) {
            leaderBoardError();
            setShareDialog(false);
            setCreateLeaderBoard(false);
        }


        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [creatingLeaderBoard, successLeaderBoard, errorLeaderBoard, createLeaderboard]);

    const showSuccess = (data) => {
        toast.current.show({
            severity: "success",
            summary: t("product.success_summary"),
            detail: data.message,
            life: 3000,
        });
    };
    const showError = (data) => {
        toast.current.show({
            severity: "error",
            summary: t("product.error_summary"),
            detail: t("product.archive_error"),
            life: 3000,
        });
    };

    const leaderBoardError = (data) => {
        toast.current.show({
            severity: "error",
            summary: t("product.error_summary"),
            detail: t("products.leaderBoard_error"),
            life: 3000,
        });
    };

    const moneyTemplate = (tier, e) => {
        const customPolicy = tier.policy === "CUSTOM";
        return <div style={{ color: "black", fontWeight: "800" }} className={tier[e.field] ? "rev" : "no-rev"}>
            {tier[e.field] ? <FormatCurrency
                amount={tier[e.field]}
                currencySymbol={currencySymbol}
                currencyFormat={currencyFormat}
            /> : customPolicy ? t("fixed_sub") : t("fixed_sub")}</div>
    };

    const paymentMoneyTemplate = (tier, e) => {
        return <section className="payment-col" >
            <div style={{ display: "flex" }}>
                <div className={tier.collected ? "collected" : "no-revn"}>{tier.collected ?
                    <FormatCurrency
                        amount={tier.collected}
                        currencySymbol={currencySymbol}
                        currencyFormat={currencyFormat}
                    /> : null}
                </div>
                <div className="coll-title">{tier.collected ? t("product.collected") : null}</div></div>

            <div style={{ display: "flex", width: "10rem", marginTop: "3px" }}>
                <div className={tier.revenue ? "revn" : "no-revn"}>
                    {tier.revenue ?
                        < FormatCurrency
                            amount={tier.revenue}
                            currencySymbol={currencySymbol}
                            currencyFormat={currencyFormat}
                        /> : null}
                </div>
                <div className="rev-title">{tier.revenue ? t("products.revenue") : null}</div></div>
        </section>
    };

    const statusTemplate = (rowData, e) => {
        const lastModifiedDateFunc = () => {

            return <div>
                <span className="products-labelOnDate">{formatDateTime(rowData.lastModifiedDate)}</span>
            </div>
        }
        const createdOnDateFunc = () => {
            return <div>
                <span className="products-labelOnDate">{formatDateTime(rowData.createdDate)}</span>
            </div>
        }

        return <div className="stat-cont">{rowData[e.field] &&
            (<span className={`product-badge status-${rowData[e.field] ? rowData[e.field].toLowerCase() : ""} status-align`}>{rowData[e.field]}</span>)}
            <div>{rowData?.lastModifiedDate ? <span className="stat-modified">
                <span className="labelOn">{t("product.modified")}</span>
                <span>{lastModifiedDateFunc()}</span>
            </span>
                :
                <span className="status-dates">
                    <span className="labelOn">{t("product.created")}</span>
                    <div>{createdOnDateFunc()}</div>
                </span>}
            </div>
        </div>
    };

    const incidenceTemplate = (rowData) => {
        return <div className="subs-col flex">
            <span style={{ fontWeight: "bold", marginRight: "2px" }} className="subsValues">{rowData.incidence}</span>
            <span className="subsTitle">{t("product.subscriptions")}</span>
        </div>
    }

    const durationTemplate = (rowData) => {
        if (rowData) {
            return <div className="duration-content bill-period">{rowData.plan?.billingPeriod ? <span id="planPeriod">{formatBillingPeriodText(rowData.plan?.billingPeriod)}</span> : null}</div>;
        }
    };

    const subsTemplate = (rowData, e) => {
        return <div className="subs-template-content">
            <div className="space-start">
                <div className="subscriptionReference plan-nav" style={{ marginBottom: "0px" }}
                    onClick={() => {
                        navigate(`/products/plan/detail/${rowData.planId}`);
                    }}
                >
                    {rowData.planName}
                </div>
            </div>
            <div style={{ textAlign: "start" }}>
                <div className="space"> <span className="cust-name">{rowData.customer.name}</span></div>
                <div><p className="cust-phoneNo">{rowData.customer.phoneNo}</p></div>
            </div>
            {rowData.setupAmount ? <div style={{ textAlign: "start", marginBottom: "0.5rem" }}>
                <span className="setup_fee_tag">{t("common.setup_fee_label")}</span>
                <FormatCurrency
                    amount={rowData.setupAmount}
                    currencySymbol={currencySymbol}
                    currencyFormat={currencyFormat}
                    className="setup_fee_value"
                />
            </div> : null}
        </div>
    }

    const upcomingTransactionColumn = [
        {
            header: t("products.payment_schedule"),
            className: "plans-name",
            alignHeader: "left",
            body: (tier) => (
                <div className="schedule-main-content">
                    <div className="space-start">
                        <span style={{ display: "flex", width: "6rem", justifyContent: "center" }} className={`subscription-status status-${tier.scheduleStatus}`}>
                            {tier.scheduleStatus.toUpperCase()}
                        </span>
                    </div>
                    <div style={{ textAlign: "start" }}>
                        <div className="space"><span className="cust-scheduledFor">{t("subscriber.scheduled_for")}</span></div>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <span className="product_scheduledFor">{tier.scheduledFor ? formatDateTime(tier.scheduledFor) : "--"}</span>
                        </div>
                    </div>
                </div>
            ),
            bodyClassName: "payments-schedule-body"
        },

        { field: "scheduledDate", alignHeader: "left", body: subsTemplate, header: t("products.subscription"), bodyClassName: "schedule-date-body" },

        { field: "amountDue", alignHeader: "left", header: t("amount"), body: moneyTemplate, bodyClassName: "money-template" },
    ];

    const tabs = [
        {
            label: t("products.plans"),
            columns: [
                { field: "plan.status", body: (row, e) => statusTemplate(row.plan, { field: "status" }), alignHeader: "center", header: t("subscriber.status"), headerClass: "stat-header" },
                {
                    field: "name",
                    alignHeader: "left",
                    header: t("products.name/dec"),
                    body: (tier) => (
                        <div className='name-desc' >
                            <div className="flex" style={{ paddingBottom: "0.2rem" }}>
                                {tier?.plan.policy === "TARGET" ?
                                    (<>
                                        <p className="text-left policy mb-0 mr-2">{t('billing', { val: tier?.plan.policy })}</p>
                                        <p className="text-left policy target-stat mb-0 mr-1">{tier?.plan.targetEqualParts ? t("product.equal") : t("product.varying")}</p>
                                        {(tier?.plan.targetEqualParts && tier?.plan.recoverMissed) && <p className="text-left policy target-stat-miss mb-0">{t('product.recovery')}</p>}
                                    </>
                                    ) :
                                    <p className="text-left policy mb-0">{tier?.plan.policy === "FIXED" ? t("products.fixed_billing").toUpperCase() : tier?.plan.policy === "CUSTOM" ? t("products.custom_billing").toUpperCase() : t('billing', { val: tier?.plan.policy })}</p>
                                }
                            </div>
                            <div className="flex align-items-center gap-2">
                                <p onClick={() =>
                                    navigate("/products/plan/detail/" + tier.id)}
                                    className="plans-name link">{tier.planName}</p>
                                <AutoBillingBadge collectionMode={tier.plan.collectionMode} />
                            </div>

                            {tier.plan.description && <p className="plan-description">{tier.plan.description}</p>}
                            {
                                tier.plan.setup && <div className="setup_fee_main_div">
                                    <span className="setup_fee_tag">{t("common.setup_fee_label")}</span>
                                    <FormatCurrency
                                        amount={tier.plan.setup}
                                        currencySymbol={currencySymbol}
                                        currencyFormat={currencyFormat}
                                        className="setup_fee_value"
                                    />
                                </div>
                            }
                        </div >
                    ),
                },
                {
                    field: "plan.cost",
                    alignHeader: "left",
                    header: t("amount"),
                    body: (row, e) => (<div>
                        <span className={row.plan.flex ? "no-rev-flex" : "amt-col"}>
                            {row.plan.flex ? t("products.flexible_amount") : moneyTemplate(row.plan, { field: "cost" })}
                        </span>
                    </div>),
                },
                { field: "plan.billingPeriod", alignHeader: "left", body: durationTemplate, header: t("products.frequency") },
                { field: "incidence", alignHeader: "left", header: t("subscriptions"), body: incidenceTemplate },
                { field: "revenue", alignHeader: "left", header: t("products.payments"), body: paymentMoneyTemplate },
            ],
            data: state.tiers,
            count: state.totalPlanSummaryCount,
            index: 0
        },
        {
            label: t("subscriber.upcoming"),
            data: state.pending,
            columns: upcomingTransactionColumn,
            count: state.pendingCount,
            index: 3
        },
    ];

    const reject = () => {
        setArchive(false);
    };

    const accept = () => {
        if (tierArchive) {
            setState((state) => ({ ...state, planArchiving: true }));
            archivePlan(state.planGroup.id, defMembership.id);
            setTierArchive(false);
        } else {
            setState((state) => ({ ...state, archived: true }));
            archivePlanGroup(state.planGroup.id, defMembership.user.login);
        }
    };

    const archiveFooter = () => {
        return (
            <div>
                <Button
                    id="footer-btn-cancel"
                    label={t("cancel")}
                    icon="pi pi-times"
                    onClick={reject}
                />
                <Button
                    id="archive-btn"
                    loading={archiving}
                    label={t("share.archive")}
                    icon="pi pi-check"
                    onClick={accept}
                />
            </div>
        );
    };

    const totalNumber =
        tabs[activeTab].index === 0
            ? state.totalPlanSummaryCount
            : tabs[activeTab].index === 3
                ? state.pendingCount
                : null


    const paginationCheck = tabs[activeTab].index === 0 || tabs[activeTab].index === 3;

    const loadingSpinner = fetchingPlansSummary || fetchingPending;

    const onChange = (e) => {
        if (e.pageCount <= 1) {
            return;
        }
        else if (tabs[activeTab].index === 0) {
            getPlanGroupPlansSummary(planId, { page: e.page, sort: state.planSummarySort, size: state.size });
            setState((state) => { return { ...state, page: e.page, first: e.first } })
        }
        else if (tabs[activeTab].index === 3) {
            getPlanGroupPaymentPending(planId, { page: e.page, sort: state.scheduledFor, size: state.size });
            setState((state) => { return { ...state, page: e.page, first: e.first } })
        }
        else {
            return;
        }
    }



    const toogleConfirmVisible = () => {
        setState({ ...state, confirmVisible: true, })
    }
    const toogleConfirmInviteSubscriber = () => {
        setState(state => { return { ...state, confirmVisible: !state.confirmVisible } })
    }

    const hideInvite = () => {
        toogleConfirmInviteSubscriber()
        setState({ ...state, checking: false, success: false, requesting: false, confirmVisible: false })
    }

    const rejectInvite = () => {
        setState({ ...state, checking: false, success: false, requesting: false, confirmVisible: false, })
    }

    const planShare = () => {
        if (state.planGroup.boardUrl) {
            setShareDialog(true);
            setState((state) => ({
                ...state,
                sharedTier: {
                    shortUrl: state.planGroup.boardUrl,
                    plan: `${t("products.leaderBoard_for")} ${state.planGroup.name}`,
                    planGroupId: state.planGroup.id,
                    isLeaderboard: true,
                },
            }));
        }
        else {

            setState({ ...state, confirmVisible: true, })
        }

    }

    return (
        <div className="planDetailScreen product-detail-screen" >
            <MarkAsPaid displayDialog={displayBasic} onHide={() => { setDisplayBasic(false) }}
                scheduleId={state.id}
                scheduledDate={state.scheduledDate}
                isFlexTrue={state.isAmountTrue}
                callbackFunctions={() => {
                    getPlanGroup(planId);
                    getSettlementsGroup(planId);
                    getPlanGroupPaymentPending(planId);
                    getPlanGroupPaymentPendingCount(planId);
                    getPaymentTrackGroup(planId);
                    getPaymentTrackGroupCount(planId);
                    getPlanGroupPlansSummary(planId);
                }}
            />

            {(state.confirmVisible) &&
                <ConfirmDialog visible={state.confirmVisible} onHide={hideInvite} className="confirm_close_btn" id="leaderboard_dialog"
                    message={<div style={{ marginTop: "0.6rem" }}>
                        <span className="confirm_invite_detail detail">{t("product.leaderboard_confirm_message")}</span>
                    </div>}
                    header={t("product.leaderboard_confirm_header")}
                    acceptLabel={t("product.leaderboard_confirm_accept")}
                    rejectLabel={t("product.leaderboard_confirm_reject")}
                    accept={() => {
                        leaderBoard(state.planGroup.id)
                        setCreateLeaderBoard(true)
                    }} reject={rejectInvite} />
            }

            <Toast
                ref={toast}
                onRemove={(message) => {
                    if (message.severity === "success") {
                        getActivePlanGroups(defMembership.business.id);
                        getPlanGroup(planId);
                        getSettlementsGroup(planId);
                        getPlanGroupPaymentMissed(planId);
                        getPlanGroupPaymentMissedCount(planId);
                        getPlanGroupPaymentPending(planId);
                        getPlanGroupPaymentPendingCount(planId);
                        getPaymentTrackGroup(planId);
                        getPaymentTrackGroupCount(planId);
                        getPlanGroupPlansSummary(planId);
                        getPlanGroupCustomersSummary(planId);
                        getPlanExternalPayments(defMembership.business.id, planId)
                        setArchive(false);
                    }
                }} />
            <Dialog
                header={t("Archive")}
                visible={archive}
                onHide={() => setArchive(false)}
                footer={archiveFooter()}
                className="tier_dialog"
                id="tier_dialog"
                style={{ width: "300px" }}
            >
                <div className="archive-dialog-content">
                    <p style={{ display: "flex", justifyContent: "center" }}>
                        <i
                            className="pi pi-exclamation-circle"
                            style={{
                                color: "#D0021B",
                                fontSize: "40px",
                                fontWeight: "bolder",
                            }}
                        />
                    </p>
                    <div style={{ padding: "10px" }}>
                        <div style={{ marginBottom: "0.5rem" }}>
                            <span>
                                {t("product.archive_question")}{" "}
                                <span style={{ fontWeight: "bold", color: "#000" }}>
                                    {state.rowData?.name}
                                </span>{"?"}{" "}
                            </span>
                        </div>
                        <p className="archive-notice">
                            {t("product.archive_notice")}
                        </p>
                    </div>
                    <hr style={{ border: "1px solid #F2F2F2" }} />
                </div>
            </Dialog>

            <ProductDetailCardInsights  {...{ state, t, defMembership, planGroup, fetchingPerformance, setArchive, setProductInfoVisible, setSharePlanDialog, planShare, leaderBoard, toogleConfirmVisible }} />

            <h6 className="title-tile products-title-tile">{t("products.activities")}</h6>
            <CustomDataTable
                value={tabs[activeTab].data}
                columns={tabs[activeTab].columns}
                tabs={tabs.map(({ label, i }) => ({ label, i }))}
                setActiveTab={setActiveTab}
                activeTab={activeTab}
                setState={setState}
                tableClassName="tier_detail_data_table"
                children={null}
                rows={state.size}
                loading={loadingSpinner}
                tab={state.tabChange}
                paginator={!paginationCheck ? true : false}
            />
            {paginationCheck ?
                <Paginator
                    rows={state.size}
                    first={state.first}
                    totalRecords={totalNumber}
                    onPageChange={onChange}
                /> : ""
            }
            <ProductEdit
                product={productInfoVisible}
                onHide={() => setProductInfoVisible({})}
                setShowProductEdit={setEditProductToast}
                showProductEdit={editProductToast}
                id={planId}
                triggerRender={triggerRender}
                setTriggerRender={setTriggerRender} />

            <SharePlan
                visible={sharePlanDialog}
                setSharePlanDialog={setSharePlanDialog}
                defMembership={defMembership}
                sharedPlan={state.sharedPlan}
                reportable={reportable}
                reportCode={reportCode}
                setReportCode={setReportCode}
                hideAmount={hideAmount}
                dialogClosed={dialogClosed}
                setDialogClosed={setDialogClosed}
            />

            <ShareUrl
                visible={shareDialog}
                setShareDialog={setShareDialog}
                sharedTier={state.sharedTier}
                leaderBoard={true}
                copying={state.copying}
                generating={creatingLeaderBoard}
                defMembership={defMembership}
                onLeaderboardRemoved={() => {
                    getPlanGroup(planId);
                    getActivePlanGroups(defMembership.business.id);
                }}
            />
        </div>
    );
};

export default ProductDetail;